import * as joint from '@joint/core'

/**
 * C4 Pipe shape - horizontal cylinder (like a pipeline or queue)
 */
export const C4Pipe = joint.dia.Element.define(
  'c4.Pipe',
  {
    size: { width: 280, height: 120 },
    attrs: {
      body: {
        refX: 20,
        refY: 0,
        refWidth: 'calc(w - 40)',
        refHeight: '100%',
        fill: '#438dd5',
        stroke: '#2e6295',
        strokeWidth: 2,
      },
      leftCap: {
        refX: 0,
        refY: '50%',
        rx: 20,
        ry: 60,
        fill: '#2e6295',
        stroke: '#2e6295',
        strokeWidth: 2,
      },
      rightCap: {
        refX: '100%',
        refY: '50%',
        rx: 20,
        ry: 60,
        fill: '#438dd5',
        stroke: '#2e6295',
        strokeWidth: 2,
      },
      nameLabel: {
        refX: '50%',
        refY: '30%',
        textVerticalAnchor: 'middle',
        textAnchor: 'middle',
        fontSize: 14,
        fontWeight: 'bold',
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '',
      },
      typeLabel: {
        refX: '50%',
        refY: '50%',
        textVerticalAnchor: 'middle',
        textAnchor: 'middle',
        fontSize: 11,
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '[Queue]',
      },
      descriptionLabel: {
        refX: '50%',
        refY: '70%',
        textVerticalAnchor: 'top',
        textAnchor: 'middle',
        fontSize: 11,
        fill: '#ffffff',
        fontFamily: 'Open Sans, sans-serif',
        text: '',
        textWrap: {
          width: '75%',
          height: 30,
          ellipsis: true,
        },
      },
    },
  },
  {
    markup: [
      { tagName: 'rect', selector: 'body' },
      { tagName: 'ellipse', selector: 'leftCap' },
      { tagName: 'ellipse', selector: 'rightCap' },
      { tagName: 'text', selector: 'nameLabel' },
      { tagName: 'text', selector: 'typeLabel' },
      { tagName: 'text', selector: 'descriptionLabel' },
    ],
  }
)

export function createPipe(
  id: string,
  name: string,
  technology: string = '',
  description: string = '',
  x: number = 0,
  y: number = 0,
  style?: {
    background?: string
    stroke?: string
    color?: string
  }
): joint.dia.Element {
  const typeText = technology ? `[Queue: ${technology}]` : '[Queue]'

  const pipe = new C4Pipe({
    id,
    position: { x, y },
    attrs: {
      body: {
        ...(style?.background && { fill: style.background }),
        ...(style?.stroke && { stroke: style.stroke }),
      },
      leftCap: {
        ...(style?.stroke && { fill: style.stroke, stroke: style.stroke }),
      },
      rightCap: {
        ...(style?.background && { fill: style.background }),
        ...(style?.stroke && { stroke: style.stroke }),
      },
      nameLabel: {
        text: name,
        ...(style?.color && { fill: style.color }),
      },
      typeLabel: {
        text: typeText,
        ...(style?.color && { fill: style.color }),
      },
      descriptionLabel: {
        text: description,
        ...(style?.color && { fill: style.color }),
      },
    },
  })

  return pipe
}
